export enum ChartPeriod {
  OneMonth = 1,
  SixMonths = 6,
  OneYear = 12,
  TwoYears = 24
}
